import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { Color } from '@app/shared/models/color.model';

export enum Size {
  'small' = '16px',
  'medium-small' = '20px',
  'medium' = '24px',
  'large' = '32px',
}

export enum Style {
  'bold' = 'ph-bold',
  'fill' = 'ph-fill',
  'light' = 'ph-light',
}

export enum Align {
  'left' = 'left',
  'right' = 'right',
  'center' = 'center',
}

export enum TooltipPosition {
  right = 'right',
  left = 'left',
}

const defaultSize = Size.medium;

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
})
export class IconComponent {
  @Input() phosphorClass: string = 'ph-question';

  @Input() iconStyle?: Style | undefined;

  @Input() size?: Size = defaultSize;

  @Input() color: Color | undefined = Color.greyBlack;

  @Input() align: Align = Align.center;

  @Input() tooltipText: string = '';

  @Input() tooltipPosition: TooltipPosition = TooltipPosition.right;

  defaultSize: Size = defaultSize;

  constructor(private el: ElementRef) {}

  @HostListener('mouseenter') onMouseEnter() {
    this.showTooltip();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hideTooltip();
  }

  private showTooltip() {
    if (this.tooltipText !== '') {
      const tooltip = document.createElement('tooltip');
      tooltip.innerText = this.tooltipText;
      tooltip.style.position = 'absolute';
      tooltip.style.backgroundColor = '#585d66';
      tooltip.style.fontSize = '12px';
      tooltip.style.color = '#fff';
      tooltip.style.padding = '6px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.zIndex = '9999';
      tooltip.style.fontFamily = 'Poppins", sans-serif';

      const rect = this.el.nativeElement.getBoundingClientRect();

      switch (this.tooltipPosition) {
        case TooltipPosition.left:
          tooltip.style.top = `${rect.bottom + 3}px`;
          tooltip.style.left = `${rect.left + 10}px`;
          tooltip.style.transform = 'translate(-50%, 0)';
          break;

        case TooltipPosition.right:
        default:
          tooltip.style.top = `${rect.bottom + 3}px`;
          tooltip.style.left = `${rect.left + 10}px`;
          break;
      }

      document.body.appendChild(tooltip);
    }
  }

  private hideTooltip() {
    document.querySelectorAll('tooltip').forEach((tooltip) => tooltip.remove());
  }

  get class(): string {
    if (this.iconStyle) {
      return `ph ${this.phosphorClass} ${this.iconStyle}`;
    }
    return `ph ${this.phosphorClass}`;
  }
}
